import {Component, EventEmitter, Input, OnInit, Output, ElementRef, OnDestroy} from '@angular/core';

import {IOption} from 'ng-select';
import {EvsProductService} from '../../common/services/EvsProduct.service';

@Component({
  selector: 'app-filter-products',
  templateUrl: './filter-products.component.html',
  styleUrls: ['./filter-products.component.css'],
  providers: [EvsProductService],
})
export class FilterProductsComponent implements OnInit, OnDestroy {
  @Output() selectedProductId = new EventEmitter<any>();
  @Output() selectedProductLabel = new EventEmitter<any>();
  @Output() selectedListProducts = new EventEmitter<any>();
  @Output() checkClear = new EventEmitter<any>();
  @Input() productId: any;
  @Input() product: any;
  listProducts: Array<IOption> = [];
  limitProd: number = 10;
  offsetProd: number = 0;
  searchProductQuery = '';
  tmpCountBottom = 0;
  sltProductId: any = null;
  tmp: any;
  private scrollListener: any;
  private keyupListener: any;
  constructor(private productService: EvsProductService, private el: ElementRef) {}
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnChanges(change: any) {
    let currentValue: any;
    if (change.product) {
      currentValue = change.product.currentValue;
      this.getListProduct().then(() => {
        if (currentValue) {
          if (!this.currentObj) {
            this.currentObj = {
              value: currentValue.value,
              label: currentValue.label,
            };
          }
          if (this.listProducts.map((gg) => gg.value).indexOf(currentValue.id) == -1) {
            let tmp = {
              value: currentValue.value,
              label: currentValue.label,
            };
            let arrTmp = this.listProducts;
            arrTmp.push(tmp);
            this.listProducts = arrTmp;
          }
        }
      });
    }
  }

  ngOnInit() {
    this.getListProduct().then(() => {
      if (this.product) {

        if (!this.currentObj) {
          this.currentObj = {
            value: this.product.value,
            label: this.product.label,
          };
        }
        if (
          this.listProducts.map((gg) => gg.value).indexOf(this.product.id) == -1
        ) {
          let tmp = {
            value: this.product.value,
            label: this.product.label,
          };
          let arrTmp = this.listProducts;
          arrTmp.push(tmp);
          this.listProducts = arrTmp;
        }
      }
    });

    // when scroll to bottom to load more
    this.scrollListener = (event: Event) => {
      event.stopPropagation();
      let ele = <HTMLElement>event.target;
      if (ele && this.el.nativeElement.contains(ele)) {
        let ele2 = <HTMLElement>ele.parentElement;
        if (ele2) {
          let ele3 = <HTMLElement>ele2.parentElement;
          if (ele3) {
            let ele4 = <HTMLElement>ele3.parentElement;
            if (ele4) {
              if (
                ele.className === "options" &&
                ele4.id == "drp-list-product"
              ) {
                if (ele.scrollTop === ele.scrollHeight - ele.clientHeight) {
                  this.tmpCountBottom += 1;
                  this.offsetProd = this.tmpCountBottom * this.limitProd;
                  this.tmp = this.listProducts;

                  this.getListProduct(this.searchProductQuery).then(() => {
                    let tmp2: any;
                    if (this.tmp) {
                      tmp2 = this.tmp.concat(this.listProducts);
                    }
                    this.listProducts = tmp2;
                  });
                }
              }
            }
          }
        }
      }
    };
    document.addEventListener("scroll", this.scrollListener, true);

    // call api when stop typing
    var delay = (function () {
      var timer: any = 0;
      return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    })();

    // when search
    this.keyupListener = (event: KeyboardEvent) => {
      event.stopPropagation();
      let ele = <HTMLElement>event.target;
      if (ele && this.el.nativeElement.contains(ele)) {
        let ele2 = <HTMLElement>ele.parentElement;
        if (ele2) {
          let ele3 = <HTMLElement>ele2.parentElement;
          if (ele3) {
            let ele4 = <HTMLElement>ele3.parentElement;
            if (ele4) {
              let ele5 = <HTMLElement>ele4.parentElement;
              if (ele5) {
                if (
                  ele.parentElement.className == "filter" &&
                  ele5.id == "drp-list-product"
                ) {
                  let inputEle = <HTMLInputElement>event.target;
                  let searchQuery = inputEle.value;

                  this.tmpCountBottom = 0;
                  this.offsetProd = 0;
                  this.listProducts = null;

                  delay(() => {
                    this.searchProductQuery = searchQuery;
                    this.getListProduct(this.searchProductQuery).then(() => {
                      let tmp = this.listProducts;

                      if (tmp && this.currentObj) {
                        if (
                          !tmp.some((e) => e.value == this.currentObj.value)
                        ) {
                          tmp.push(this.currentObj);
                        }
                      }

                      this.listProducts = tmp;
                    });
                  }, 500);
                }
              }
            }
          }
        }
      }
    };
    document.addEventListener("keyup", this.keyupListener);
  }

  ngOnDestroy() {
    if (this.scrollListener) {
      document.removeEventListener("scroll", this.scrollListener, true);
    }
    if (this.keyupListener) {
      document.removeEventListener("keyup", this.keyupListener);
    }
  }

  getListProduct(name?) {
    let opt: any;
    if (name) {
      opt = {
        limit: this.limitProd,
        offset: this.offsetProd,
        name,
      };
    } else {
      opt = {
        limit: this.limitProd,
        offset: this.offsetProd,
      };
    }

    return this.productService
      .getProducts(opt)
      .toPromise()
      .then((res) => {
        if (!res.error) {
          let products = res.data.products;
          this.selectedListProducts.emit(products);

          let arrTmp = [];
          for (let i = 0; i < products.length; i++) {
            let item = {
              value: products[i].id.toString(),
              label: products[i].name,
            };
            if (this.currentObj) {
              if (item.value != this.currentObj.value) {
                arrTmp.push(item);
              }
            } else {
              arrTmp.push(item);
            }
          }
          this.listProducts = arrTmp;
        }
      });
  }

  // when select option
  currentObj: any;
  selectedProduct(e) {
    this.sltProductId = e.value;
    this.selectedProductId.emit(this.sltProductId);
    this.selectedProductLabel.emit(e.label);
    this.currentObj = {
      value: e.value,
      label: e.label,
    };

    console.log(this.currentObj);
  }

  // when deselect option
  deselectedProduct(e) {
    this.sltProductId = null;
    this.selectedProductId.emit(this.sltProductId);
    this.selectedProductLabel.emit(null);
  }

  // when open select box
  opened() {
    this.tmpCountBottom = 0;
    this.offsetProd = 0;
    this.listProducts = null;
    this.searchProductQuery = "";

    this.getListProduct().then(() => {
      let tmp = this.listProducts;

      if (this.currentObj) {
        if (!tmp.some((e) => e.value == this.currentObj.value)) {
          tmp.push(this.currentObj);
        }
      }

      if (this.product) {
        if (tmp.map((gg) => gg.value).indexOf(this.product.value) == -1) {
          let obj = {
            value: this.product.value,
            label: this.product.label,
          };
          tmp.push(obj);
        }
      }

      this.listProducts = tmp;
    });
  }

  clearFilterProductLogScan(data) {
    if (data == 'log_scan_clear') {
      this.sltProductId = null;
      this.selectedProductId.emit(this.sltProductId);
      this.selectedProductLabel.emit(null);
    }
    console.log('logsacasdb', data)
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/filter-products/filter-products.component.ts